// src/firebase/config.js - VERSÃO COMPLETA (exporta tudo)
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

// ⚠️ SUBSTITUA COM SUAS CONFIGURAÇÕES REAIS ⚠️
const firebaseConfig = {
  apiKey: "AIzaSyA_ExGUx25BdW8s47WnsX3vnmqhWF7_wp8",
  authDomain: "barbearia-app-9b94d.firebaseapp.com",
  projectId: "barbearia-app-9b94d",
  storageBucket: "barbearia-app-9b94d.firebasestorage.app",
  messagingSenderId: "607741029430",
  appId: "1:607741029430:web:a995746bb12829cff73c97"
};

// Inicialize Firebase
let app;
let db;
let auth;

try {
  app = initializeApp(firebaseConfig);
  db = getFirestore(app);
  auth = getAuth(app);
  console.log('✅ Firebase inicializado com sucesso!');
} catch (error) {
  console.error('❌ Erro ao inicializar Firebase:', error);
  app = null;
  db = null;
  auth = null;
}

// Exporte TUDO
export { db, auth };
export default app;

// Também mantenha as funções de instância para compatibilidade
export const getFirestoreInstance = async () => db;
export const getAuthInstance = async () => auth;